// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

const updateHasSearchResults = (state, action) => action.hasSearchResults;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_HAS_SEARCH_RESULTS]: updateHasSearchResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/shared/reducers/has-search-results.js